/**
  * For plus minus controller.
  * 
  * Usage:
  *
  *   data-sw-plus-minus-control
  *
  *
  */

/*
var swNotifications = require('./../../lib/notifications/sw-notifications');
var _ = require('underscore');
*/
var $ = require('./../sw-jquery');

module.exports = function($fragment) {
  $fragment.swFindWithSelf('[data-sw-plus-minus-control]').each(function(i, $control) {

    $control.base        = $(this);
    $control.plus        = $control.base.children('[data-sw-plus-minus-control-plus]').first();
    $control.minus       = $control.base.children('[data-sw-plus-minus-control-minus]').first();
    $control.valueLabel  = $control.base.children('[data-sw-plus-minus-control-value]').first();
    $control.info  = $control.base.children('[data-sw-plus-minus-control-info]').first();

    $control.base.click(function( e ) {
      e.stopPropagation();
    });

    $control.plus.click(function( e ) {
      e.stopPropagation();
      $control.setValue( $control.getValue() + 1 );
    });

    $control.minus.click(function( e ) {
      e.stopPropagation();
      $control.setValue( $control.getValue() - 1 );
    });

    $control.getValue = function() {
      return $control.base.data("sw-value");
    };

    $control.setValue = function( newValue ) {
      // Set value
      $control.base.data('sw-value', newValue);

      // Send value 

      // Collect sendable data
      var sendData = {};
      var dataAttributes = $control.base.data();
      for (var key in dataAttributes) {
        var swSendAttribute = key.replace("swSend","");
        if( swSendAttribute !== key ) {
          var label = swSendAttribute.charAt(0).toLowerCase() + swSendAttribute.slice(1);
          sendData[label] = dataAttributes[key];
        }
      }
      sendData.value = newValue;
      
      // Send value
      $.ajax({
        url:    $control.base.data("sw-endpoint"),
        type: "POST",
        data: {"jsonObj": window.JSON.stringify([sendData])}
      }).done(function( response ) {
          // TODO: this function should be refactored outside the UI component since it's usecase specific
          response = $.parseJSON( response );
          response = $.parseJSON( response.data );
          
          for (var i in response) {
            if( parseInt( response[i].entityTypeId, 10 ) === parseInt( sendData.entityTypeId, 10 ) && parseInt( response[i].entityId, 10 ) === parseInt( sendData.entityId, 10 ) ) {
              $control.info.html( response[i].endDate );
            }
          }
      });

      // Update value label
      $control.updateValueLabel(newValue);
     
    };

    $control.updateValueLabel = function( newValue ) {
      
      var valueLabelPrefix = "";
      if( newValue > 0 ) {
        valueLabelPrefix = "+";
      } 
      
      $control.valueLabel.html( valueLabelPrefix + newValue );

      if( newValue === 0 ) {
        $control.valueLabel.swHide();
      } else {
        $control.valueLabel.swShow();
      }

    };

    $control.updateValueLabel($control.getValue());
    $control.base.control = $control;

  });
  
  // Find all the +1 All button
  $fragment.swFindWithSelf('[data-sw-plus-minus-control-plus-one-all]').each(function(i, plusOneAll) {

    $(plusOneAll).click( function() {
      var parentSelector      = $(plusOneAll).data('sw-plus-minus-control-plus-one-all');
      var controlPlusButtons  = $(plusOneAll).parents('.' + parentSelector).find('[data-sw-plus-minus-control] [data-sw-plus-minus-control-plus]');
      
      controlPlusButtons.click();
    });

  });

  // Find all the +/- buttons on product boxes
  $fragment.swFindWithSelf('[data-sw-product-manual-adjustment]').each(function(i, plusMinusTrigger) {
    $(plusMinusTrigger).parent().mouseleave(function() {
      $(plusMinusTrigger).find("[data-sw-product-manual-adjustment-ui]").remove();
    });
  });

};
